// extracted by mini-css-extract-plugin
export default {"section":"BlogSection_section__Mh6kh","grid":"BlogSection_grid__+EE1u","more":"BlogSection_more__2Lokh"};